import { Trial, Acervo } from 'utils/user'
import { ROOT_PATH, TRIAL_START_PATH, TRIAL_END_PATH } from 'routes/paths'
import type { LocationType } from './types'
import type { UserState } from 'utils/hooks/use-userInfo'

function getRedirectLocation(user: UserState, currentPath): LocationType {
  // Trial access verification
  const isPublic = Acervo.isPublic(user)
  const firstAccessTrial = Trial.isFirstAccessTrial(user)
  const trialExpired = Trial.isExpired(user)

  if (!firstAccessTrial && currentPath === TRIAL_START_PATH) {
    return { pathname: ROOT_PATH }
  }

  if (firstAccessTrial && !trialExpired && currentPath === TRIAL_END_PATH) {
    return { pathname: ROOT_PATH }
  }

  if (isPublic && trialExpired && currentPath !== TRIAL_END_PATH) {
    return { pathname: TRIAL_END_PATH }
  }

  if (firstAccessTrial && !trialExpired && currentPath !== TRIAL_START_PATH) {
    return { pathname: TRIAL_START_PATH }
  }

  return {
    pathname: ''
  }
}

export default {
  getRedirectLocation
}
